import { useEffect, useRef, type RefObject } from 'react'
import { trackEvent } from './useTracking'

export const useEngagementTime = (sectionName: string, ref: RefObject<HTMLElement | null>) => {
  const startTime = useRef<number | null>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startTime.current = Date.now()
        } else if (startTime.current) {
          const duration = Math.round((Date.now() - startTime.current) / 1000)
          if (duration > 1) {
            trackEvent('section_engagement_time', {
              section: sectionName,
              duration_seconds: duration,
            })
          }
          startTime.current = null
        }
      },
      { threshold: 0.3 }
    )
    observer.observe(el)
    return () => {
      if (startTime.current) {
        const duration = Math.round((Date.now() - startTime.current) / 1000)
        if (duration > 1) {
          trackEvent('section_engagement_time', {
            section: sectionName,
            duration_seconds: duration,
          })
        }
      }
      observer.disconnect()
    }
  }, [sectionName, ref])
}

export const useSessionDuration = () => {
  const sessionStart = useRef(Date.now())

  useEffect(() => {
    const handler = () => {
      const duration = Math.round((Date.now() - sessionStart.current) / 1000)
      trackEvent('session_duration', { duration_seconds: duration })
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [])
}
